module.exports = __webpack_public_path__ + "static/media/qr-gpay.8c7a690d.svg";